import type React from "react";

import type { TabButtonProps } from "./TabButton.model";
import { StyledTabButton } from "./TabButton.styled";

export const TabButton: React.FC<TabButtonProps> = ({ isActive, dataCy, children, onClick }) => (
  <StyledTabButton $isActive={isActive} aria-hidden="true" data-cy={dataCy} onClick={onClick}>
    <span className="content">{children}</span>
  </StyledTabButton>
);
